module.exports = __webpack_public_path__ + "static/media/register_visual.cf3d490e.png";